import React from "react";
import { Data } from "../../../../components/Formatters/DateTime";

const columns = [
  {
    name: "Nº OS",
    selector: "sqOrdemServico",
    minWidth: "70px",
    center: true,
    sortable: true,
  },
  {
    name: "Tipo de Ação Fiscal",
    selector: "dsTipoAcaoFiscal",
    minWidth: "250px",
    center: true,
    sortable: true,
  },
  {
    name: "Período de Fiscalização",
    selector: "dtInicio",
    minWidth: "250px",
    center: true,
    sortable: true,
    cell: (row) => (
      <span>
        <Data value={row.dtInicio} /> à <Data value={row.dtFim} />
      </span>
    ),
  },
  {
    name: "Auto de Infração",
    selector: "nuProdutoAcaoFiscal",
    minWidth: "180px",
    center: true,
    sortable: true,
  },
  {
    name: "Situação Ação Fiscal",
    selector: "stAcaoFiscal",
    minWidth: "80px",
    center: true,
    sortable: true,
  },
];

const useColumns = () => ({ columns });

export default useColumns;
